interface INameFixes {
  [key: string]: string;
}

export const nameFixes: INameFixes = {
  'ALLENZA UNIVERSITARIA': 'ALLEANZA UNIVERSITARIA',
  'NIKE  ‐  ARCADIA': 'ARCADIA - NIKE',
  INGENERIATTIVA: 'INGEGNERIATTIVA',
  'LA FINESTRA  ‐  LIBERI DI SCEGLIERE': 'LA FINESTRA ‐ LIBERI DI SCEGLIERE',
  'LA FINESTRA‐LIBERI DI SCEGLIERE': 'LA FINESTRA ‐ LIBERI DI SCEGLIERE',
  'LAFINESTRA ‐ LIBERI DI SCEGLIERE': 'LA FINESTRA ‐ LIBERI DI SCEGLIERE',
  'LA FINESTRA-LIBERI DI SCEGLIERE': 'LA FINESTRA ‐ LIBERI DI SCEGLIERE',
  'LA FINESTRA- LIBERI DI SCEGLIERE': 'LA FINESTRA - LIBERI DI SCEGLIERE',
  '#NUOVAIBLA': 'NUOVA IBLA',
  NUOVAIBLA: 'NUOVA IBLA',
  'SANI LAB': 'SANILAB',
  ECONOMIATTIVA: 'ECONOMIA ATTIVA',
  'WE LOVE UNICT/CREDIAMOCI': 'WE LOVE UNICT',
  'WE LOVE UNICT ‐ CREDIAMOCI': 'WE LOVE UNICT',
  'WE LOVE UNICT - ARES': 'WE LOVE UNICT',
  'WE LOVE‐AZIONE UNIVERSITARIA': 'WE LOVE UNICT ‐ AZIONE UNIVERSITARIA',
  'PARTECIPA ‐ SOS GIURISTI': 'PARTECIPA',
  'ARCADIA ‐ REVOLUTION': 'ARCADIA REVOLUTION',
  'ARCADIA ‐ EUREKA ‐ LIBERADEMOS': 'ARCADIA',
  'ARCADIA ‐ SVEGLIATI UNIVERSITÀ': 'ARCADIA',
  'ARCADIA ‐ LIBERADEMOS': 'ARCADIA',
  'ARCADIA SANILAB': 'ARCADIA‐SANILAB',
  'ARCADIA ‐ ORIZZONTE': 'ARCADIA',
  'ACTEA‐LA FINESTRA': 'LA FINESTRA‐ACTEA',
  UDU: 'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'UDU - UNIONE DEGLI UNIVERSITARI': 'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'UDU ‐ UNIONE DEGLI UNIVERSITARI': 'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'UDU ‐ UNIONE DEGLI UNIVERSITARI ‐ KOINÈ':
    'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'UDU RETE UNIVERSITARIA NAZIONALE LISTE INDIPENDENTI':
    'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'UDU - RETE UNIVERSITARIA NAZIONALE LISTE INDIPENDENTI':
    'UDU  ‐  UNIONE DEGLI UNIVERSITARI',
  'ACTEA - ARCADIA': 'ACTEA  ‐  ARCADIA',
  'ACTEA ‐ ARCADIA': 'ACTEA  ‐  ARCADIA',
  'NIKE ‐ ARCADIA': 'NIKE',
  'NIKE‐ARCADIA': 'ARCADIA - NIKE',
  'DISUM NIKE': 'DISUM‐NIKE',
  'ARCADIA ‐ ORRIZZONTE ITALIA': 'ARCADIA‐ORIZZONTE ITALIA',
  'KOINÈ ‐ ARCADIA': 'KOINÈ ARCADIA',
  'M.S.U.': 'MSU',
  'ALLEANZA ‐ CONTROCAMPUS': 'ALLEANZA  ‐  CONTROCAMPUS',
  'CONTROCAMPUS ‐ AZIONE UNIVERSITARIA': 'CONTROCAMPUS',
  'ALLEANZA  ‐  CONTROCAMPUS ‐ AZIONE':
    'ALLEANZA - AZIONE UNIVERSITARIA - CONTROCAMPUS',
  'AZIONE UNIVERSITARIA ‐ CONTROCAMPUS': 'AZIONE UNIVERSITARIA CONTROCAMPUS',
  'ALLEANZA‐AZIONE UNIVERSITARIA': 'ALLEANZA-AZIONE UNIVERSITARIA',
  'AZIONE UNIVERSITARIA‐ALLEANZA UNIVERSITARIA':
    'ALLEANZA-AZIONE UNIVERSITARIA',
  'STUDENTI PER LE LIBERTÀ ‐ AZIONE UNIVERSITARIA': 'STUDENTI PER LE LIBERTÀ',
  'STUDENTI PER LE LIBERTÀ  ‐  AZIONE UNIVERSITARIA': 'STUDENTI PER LE LIBERTÀ',
  'GIOVANI CIDEC ‐ LA FINESTRA': 'GIOVANI CIDEC  ‐  LA FINESTRA',
  'LIBERTAS LIBERI E FORTI': 'LIBERTAS',
  'LIBERTAS ‐ LIBERI E FORTI': 'LIBERTAS',
  'LIBERTAS - LIBERI E FORTI': 'LIBERTAS',
  'LIBERTAS ‐ SANILAB': 'LIBERTAS‐SANILAB',
  'LIBERTAS ‐ UNILAB': 'UNILAB',
  'LIBERTAS‐INMED': 'LIBERTAS-INMED',
  INMED: 'LIBERTAS-INMED',
  'P.D. - STUDENTI DEMOCRATICI': 'PARTITO DEMOCRATICO - STUDENTI DEMOCRATICI',
  PD: 'PARTITO DEMOCRATICO - STUDENTI DEMOCRATICI',
  'PD - STUDENTI DEMOCRATICI': 'PARTITO DEMOCRATICO - STUDENTI DEMOCRATICI',
  'OBIETTIVO STUDENTI - ATENEO STUDENTI':
    'OBIETTIVO STUDENTI – ATENEO STUDENTI',
  'LINK‐STUDENTI INDIPENDENTI ‐ LETTERE': 'LINK ‐ STUDENTI INDIPENDENTI',
  'LINK‐STUDENTI INDIPENDENTI ‐ LINGUE': 'LINK ‐ STUDENTI INDIPENDENTI',
  'CONTROCAMPUS ‐ POPOLO DEGLI STUDENTI ‐ LIBERI E FORTI':
    'CONTROCAMPUS ‐ POPOLO DEGLI STUDENTI',
  "UNIVERSITA' POPOLARE - SPL": 'UNIVERSITÀ POPOLARE ‐ SPL',
  'UNIVERSITÁ POPOLARE': 'UNIVERSITÀ POPOLARE',
  "UNIVERSITA' POPOLARE GENERAZIONE ATTIVA": 'UNIVERSITÀ POPOLARE',
  "AGORA' ‐ GENERAZIONE ATTIVA": 'AGORÀ',
  'UNITI PER I FUORISEDE': 'UNITI PER I FUORI SEDE',
};

export default nameFixes;
